/** @format */

import template from './gb-add-thermometer-widget.html';

export const GbAddThermometerWidgetComponent = {
    template,
    require: {
        gbPresenter: '^^',
    },
    bindings: {
        widget: '=',
    },
    controller: class GbAddThermometerWidgetComponent {
        constructor($gbThermometerProjectorWidget, $translate) {
            'ngInject';

            this.$gbThermometerProjectorWidget = $gbThermometerProjectorWidget;
            this.$translate = $translate;
        }

        getWidget() {
            return this.widget;
        }

        addWidget() {
            let widget = new this.$gbThermometerProjectorWidget({
                opacity: 1,
                fundraising_progress: 1,
                thermometer_background_color: '#FAFAFA',
                thermometer_border_color: '#263238',
                thermometer_color: '#F44336',
                border_width: '8',
                width: null,
                width_unit: '%',
                height: 70,
                height_unit: '%',
                x: 50,
                y: 15,
                x_unit: '%',
                y_unit: '%',
            });

            this.gbPresenter.tempWidgets.push(widget);
        }
    },
};
